import combine from './combine/combine';

const feeds = {
    'clients.feeds.general': 'Algemeen',
    'clients.feeds.add': 'Feed toevoegen',
    'clients.feeds.edit': 'Feed bewerken',

    'clients.feeds': 'Feeds',
    'clients.feeds.name': 'Naam',
    'clients.feeds.type': 'Type',
    'clients.feeds.layout': 'Layout',
    'clients.feeds.host': 'Host',
    'clients.feeds.host_extra': 'Extra host',
    'clients.feeds.authentication_required': 'Authenticatie verplicht',
    'clients.feeds.authentication_user': 'Gebruikersnaam',
    'clients.feeds.authentication_password': 'Wachtwoord',
    'clients.feeds.stock_required': 'Enkel indien op voorraad',

    'clients.feeds.ftp_settings': 'FTP-instellingen',
    'clients.feeds.path': 'Server pad',
    'clients.feeds.file_name': 'Bestandsnaam van feed',

    'clients.feeds.ftp_images_settings': 'Afbeelding instellingen',
    'clients.feeds.ftp_download_images': 'Afbeeldingen downloaden van FTP',

    'clients.feeds.file_upload_settings': 'File upload instellingen',
    'clients.feeds.choose_file': 'Kies bestand',
    'clients.feeds.choose_extra_file': 'Kies extra bestand (optioneel)',

    'clients.feeds.xml_settings': 'XML-instellingen',
    'clients.feeds.product_node_name': 'Naam van de product node',

    'clients.feeds.csv_settings': 'CSV-instellingen',
    'clients.feeds.seperator': 'Scheidingsteken',
    'clients.feeds.word_seperator': 'Scheidingsteken woorden',
    'clients.feeds.rows_ignore': 'Negeer X aantal rijen',
    'clients.feeds.first_row_names': 'Eerste rij bevat kolomnamen',

    'clients.feeds.settings': 'Feed instellingen',
    'clients.feeds.notation': 'Decimaal scheidingsteken prijs',

    ...combine,
};

export default feeds;
